import { Constants } from "../../../config/appConstants";
import Api from "../../../services/api/serviceCall"
import { replaceNullWithStringInObject } from "../../../services/utility";
import { MessageBox } from "../../sharedComponent/messageBox";
import moment from 'moment';

const getTimeCardData = (timeRecords, timeRecordId) => {
    const filteredTimeRecords = timeRecords.find(a => a.timeRecordIds.some(a => a === timeRecordId))?.timecardData;
    const findtimeCardData = filteredTimeRecords.find(a => a.timeRecordID === timeRecordId);
    const timeCarData = {
        stHours: findtimeCardData.stHours,
        otHours: findtimeCardData.otHours,
        dtHours: findtimeCardData.dtHours,
        employeeName: `${findtimeCardData.employeeNumber} - ${findtimeCardData.fullName}`,
        startTime: findtimeCardData.startTime,
        endTime: findtimeCardData.endTime,
        lunchStartTime: findtimeCardData.lunchStartTime,
        lunchEndTime: findtimeCardData.lunchEndTime,
        createdDate: findtimeCardData.createdDate,
    };
    return timeCarData;
}

export const getAttestation = (url, timeRecords, timeRecordId, that) => {
    const timeCarData = getTimeCardData(timeRecords, timeRecordId);
    return new Promise((resolve, reject) => {
        Api.Get(url, that).then(response => {
            if (response.success) {
                let attestationDetails = response.data ?? EmptyAttestDetails();
                replaceNullWithStringInObject(attestationDetails);
                attestationDetails = { ...attestationDetails, ...timeCarData };
                resolve(attestationDetails);
            } else {
                MessageBox(response.message, Constants.ERROR);
                resolve(EmptyAttestDetails());
            }
        }).catch(err => {
            reject(err);
        });
    });
}

export const EmptyAttestDetails = () => {
    return {
        approvedAttestation: "",
        rejectionA: "",
        rejectionB: "",
        rejectionC: "",
        supervisorOverride: "",
        overrideReason: "",
        languageSelected: Constants.ATTESTATION_LANGUAGE_ENGLISH,
        attestationStatus: "",
        otherReason: "",
        attachmentContent: "",

        stHours: 0,
        otHours: 0,
        dtHours: 0,
        employeeName: "",
        employeeNumber: "",
        startTime: "",
        endTime: "",
        lunchStartTime: "",
        lunchEndTime: "",
        attestTimeCardIds: [],
        signatureAttachment: {},
        createdDate: new Date(),

        isSignatureExist: false,
    }
}

export const AttestationlanguageText = {
    [Constants.ATTESTATION_LANGUAGE_ENGLISH]: {
        yesText: Constants.YES_TEXT,
        noText: Constants.NO_TEXT,
        approvedText: Constants.APPROVED_ATTESTATION_TEXT,
        rejectionAText: Constants.REJECTION_A_TEXT,
        rejectionBText: Constants.REJECTION_B_TEXT,
        rejectionCText: Constants.REJECTION_C_TEXT,
    },
    [Constants.ATTESTATION_LANGUAGE_SPANISH]: {
        yesText: Constants.SPANISH_YES_TEXT,
        noText: Constants.NO_TEXT,
        approvedText: Constants.APPROVED_ATTESTATION_SPANISH_TEXT,
        rejectionAText: Constants.REJECTION_A_SPANISH_TEXT,
        rejectionBText: Constants.REJECTION_B_SPANISH_TEXT,
        rejectionCText: Constants.REJECTION_C_SPANISH_TEXT,
    },
};

export const checkTrue = (fst, snd) => {
    return fst === snd;
};

export const AttestationModalUtils = (approved, supervisor, languageSelected) => {
    const { yesText, noText, approvedText, rejectionAText, rejectionBText, rejectionCText } = AttestationlanguageText[languageSelected];
    const isAttestationApproved = checkTrue(approved, Constants.ATTESTATION_YES);
    const isAttestationRejected = checkTrue(approved, Constants.ATTESTATION_NO);
    const isAttestationOverride = checkTrue(supervisor, Constants.ATTESTATION_YES);

    return { yesText, noText, approvedText, rejectionAText, rejectionBText, rejectionCText, isAttestationApproved, isAttestationRejected, isAttestationOverride }
}

export const CheckEnterHours = (hours) => {
    return hours > Constants.ENTER_HOURS_THRESHOLD;
}

export const formatAttestationDate = (date) => {
    return `${moment(date).format('ddd')} ${moment(date).format('MM/DD/YYYY')}`;
}